/* import __COLOCATED_TEMPLATE__ from './survey-circle-checkmark.hbs.js'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default class SurveyCircleCheckmark extends SvgIcon {}